import { getJson } from 'utils/http/getJson';

export async function getSynonymSearchApiKey(): Promise<string> {
  return getJson<{ searchApiKey: string }>('/data/synonyms-api-key').then(
    ({ searchApiKey }) => searchApiKey,
  );
}
